import { useSyncExternalStore } from "react";

import { type WordWriteLockHolds, wordWriteLockHolds } from "../utils/word-write-lock-holds";

export const useWordWriteLockHeld = (holds: WordWriteLockHolds = wordWriteLockHolds): boolean =>
    useSyncExternalStore(holds.subscribe, holds.isHeld);
